export default __webpack_public_path__ + "static/media/payment-success.70193ede.svg";